import { axiosInstance } from 'boot/axios.js'

export async function query(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'motorcycles',
      method: 'GET',
      params: queryParams
    })
    ctx.commit('items', response.data.items)
    ctx.commit('pagination', response.data.pagination)
    return response
  } catch (e) {
    throw e
  }
}

export async function widthMeasures(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'motorcycles/width-measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('widthMeasures', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function heightMeasures(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'motorcycles/height-measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('heightMeasures', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function rimMeasures(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'motorcycles/rim-measures',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('rimMeasures', response.data.items)
    return response
  } catch (e) {
    throw e
  }
}

export async function brands(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'motorcycles/brands',
      params: {
        sort: 'name',
        limit: 100,
        'filters[where][status][eq]': 'ACTIVE',
        ...queryParams
      },
      method: 'GET'
    })
    ctx.commit('brands', response.data.items)
  } catch (e) {
    throw e
  }
}

export async function models(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: parseUrl('motorcycles/models', queryParams),
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('models', response.data.items)
  } catch (e) {
    throw e
  }
}

export async function years(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: parseUrl('motorcycles/years', queryParams),
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('years', response.data.items)
  } catch (e) {
    throw e
  }
}

export async function version(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: parseUrl('motorcycles/versions', queryParams),
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('version', response.data.items)
  } catch (e) {
    throw e
  }
}

export async function tyres(ctx, queryParams = {}) {
  try {
    const response = await axiosInstance({
      url: 'motorcycles/tyres',
      params: queryParams,
      method: 'GET'
    })
    ctx.commit('items', response.data.items)
    ctx.commit('vehicle', response.data.vehicle)
    ctx.commit('pagination', response.data.pagination)
  } catch (e) {
    throw e
  }
}

function parseUrl(state, params) {
  if (state && params.id) {
    return '/' + state + '/' + params.id
  }
  return '/' + state
}
